module.exports = __webpack_public_path__ + "static/media/format_heading-one.6f296e60.svg";